import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_pr6jb6w2ga: FaireCollectionEntity = {
  token: "pbc_pr6jb6w2ga",
  type: "collection",
  name: "Blankets, Toys, & Gift Sets",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f0aa1d8540a7c29e0048f7022740160df61ec47a0fda656f6df9a10c0272a78.jpeg",
  itemCount: 140,
  description:
    "Discover organic cotton baby blankets, cuddly toys, and thoughtful gift sets designed for cozy moments and meaningful gifting. Beautifully crafted for everyday comfort, baby showers, and cherished keepsakes.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:19.160Z",
    importedBy: "entity-db-import-collections",
  },
};
